function EditIcon({ className }) {
  return (
    <svg className={`ic ${className}`} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 23.2799V27.3333C4 27.7066 4.29333 27.9999 4.66667 27.9999H8.72C8.89333 27.9999 9.06667 27.9333 9.18667 27.7999L23.7467 13.2532L18.7467 8.25325L4.2 22.7999C4.06667 22.9332 4 23.0932 4 23.2799ZM27.6133 9.38658C28.1333 8.86658 28.1333 8.02658 27.6133 7.50658L24.4933 4.38658C23.9733 3.86658 23.1333 3.86658 22.6133 4.38658L20.1733 6.82658L25.1733 11.8266L27.6133 9.38658V9.38658Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default EditIcon;
